
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_218:13314)","fill":"#fff"}},[_c('path',{attrs:{"d":"M5.885 10.15L6.986 8.25l-.78-4.567a.473.473 0 01.4-.592h5.044a.474.474 0 01.4.592l-.806 4.552 1.097 1.901c.09.17 0 .374-.153.374H6.052c-.167.016-.27-.203-.167-.359z"}}),_c('path',{attrs:{"d":"M9.369 15.845a.269.269 0 11-.538 0L8.09 9.876h2.052l-.772 5.97z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_218:13314"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.4 .912)","d":"M0 0h17.422v17.422H0z"}})])])])
          )
        }
      }
    